module.exports = __webpack_public_path__ + "static/media/cancel.baa6bcea.svg";